import * as React from 'react'
import { Button } from 'src/design-system'

type LoadFailedProps = {
  onRetry: () => void
  what?: string
}

export const LoadFailed: React.VFC<LoadFailedProps> = ({ onRetry, what }) => (
  <div
    className="bg-gray-50 flex flex-col gap-2 items-center justify-center p-6 rounded text-center"
    role="alert"
  >
    <p className="text-gray-700 text-sm">
      {what ? `We couldn't load ${what}.` : "We couldn't load this."}
    </p>
    <Button onClick={onRetry} size="sm" variant="outline">
      Try again
    </Button>
  </div>
)
